import { useH5Mock } from "../../global/GlobalMock";
import { post } from "../../utils/Backend";
import {
  mockIntelligenceFeedList,
  mockToggleIntelCollect,
  mockToggleIntelLike,
} from "./IntelligenceFeedMock";
import type {
  IntelligenceFeedEngagementParam,
  IntelligenceFeedEngagementState,
  IntelligenceFeedListKind,
  IntelligenceFeedListQuery,
  IntelligenceFeedListResult,
} from "./IntelligenceFeedType";

const mockIntelligenceFeed = useH5Mock && false;

const listUrls: Record<IntelligenceFeedListKind, string> = {
  all: "/lark/app/intelligence/listFeed",
  liked: "/lark/app/intelligence/listFeedLiked",
  collected: "/lark/app/intelligence/listFeedCollected",
};

export const IntelligenceFeedApi = {
  async list(
    kind: IntelligenceFeedListKind,
    query: IntelligenceFeedListQuery
  ): Promise<IntelligenceFeedListResult | string> {
    if (mockIntelligenceFeed) {
      return mockIntelligenceFeedList(query, kind);
    }
    return post<IntelligenceFeedListQuery, IntelligenceFeedListResult>(
      listUrls[kind],
      query,
      { silent: true }
    );
  },

  async toggleLike(
    param: IntelligenceFeedEngagementParam
  ): Promise<IntelligenceFeedEngagementState | string> {
    if (mockIntelligenceFeed) {
      return mockToggleIntelLike(param);
    }
    return post<IntelligenceFeedEngagementParam, IntelligenceFeedEngagementState>(
      "/lark/app/intelligence/toggleIntelLike",
      param,
      { silent: true }
    );
  },

  async toggleCollect(
    param: IntelligenceFeedEngagementParam
  ): Promise<IntelligenceFeedEngagementState | string> {
    if (mockIntelligenceFeed) {
      return mockToggleIntelCollect(param);
    }
    return post<IntelligenceFeedEngagementParam, IntelligenceFeedEngagementState>(
      "/lark/app/intelligence/toggleIntelCollect",
      param,
      { silent: true }
    );
  },
};
